import Api from '../api';

export const Activities = async (segmento_id: string) => {
  const response = await Api.get(`/activities?parent_id=${segmento_id}`);

  return response.data;
};
